module.exports = __webpack_public_path__ + "static/img/2s-info-b6.05ac8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-info-b6.jpg
// module id = Uyve
// module chunks = 0